import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { DocumentZipFilters } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface Props {
  matterId: string;
  subsetId: string;
}

interface CreateZipResponse {
  exportId?: string;
  jobId?: string;
}

export const useCreateDocumentZip = ({ matterId, subsetId }: Props) => {
  const { getFetchConfig } = useGetFetchConfig();

  const createDocumentZip = async (args?: DocumentZipFilters & { title?: string }): Promise<CreateZipResponse> => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        matterId,
        subsetId,
        ...args,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/matter/${matterId}/docs/create-zip/${subsetId}`, fetchConfig);
    if (!response.ok) {
      throw new Error('Failed to create document zip');
    }

    return await response.json();
  };

  const {
    mutate: createZip,
    mutateAsync: createZipAsync,
    isLoading: isCreatingZip,
    error,
  } = useMutation(createDocumentZip);

  return { createZip, createZipAsync, isCreatingZip, error };
};
